<template>
  <v-editor
    v-if="parentId"
    :partnerId="parentId"/>
</template>

<script>
import VEditor from '@/components/organisms/editor/VEditor.vue'
import { StudentRepository } from '@/repository/StudentRepository'
import { firestore } from '@/repository/client/firestore'

export default {
  components: {
    VEditor,
  },
  data() {
    return {
      index: null,
      parentId: ""
    }
  },
  async created() {
    const repo = new StudentRepository(firestore)
    this.index = this.$route.params.index
    this.studentIds = this.$store.getters.teacher.studentIds
    this.students = await repo.collect(this.studentIds)
    this.parentId = this.students.getParentIds()[this.index]
  }
}
</script>